module.exports = __webpack_public_path__ + "static/media/savio21.0ec6daee.jpg";